"use strict";
/*
 * Created on 12. 7. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var CompetitorReferentialPrice_1 = require("../../price-calculation/model/CompetitorReferentialPrice");
/**
 * Competitor Price Change Report DTO
 *
 * @author SKu
 */


var CompetitorPriceChangeReportDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CompetitorPriceChangeReportDTO, _DomainObject_1$Domai);

  /**
   * DTO used for CompetitorPriceChange report
   * @param competitorId release name
   * @param competitorName instance of ProductName
   * @param prices releaseItem prices DTO(that has inside FP and comments)
   */
  function CompetitorPriceChangeReportDTO(competitorId, competitorName, prices) {
    var _this;

    _classCallCheck(this, CompetitorPriceChangeReportDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceChangeReportDTO).call(this));
    _this.competitorId = competitorId;
    _this.competitorName = competitorName;
    _this.prices = prices;
    return _this;
  }

  return CompetitorPriceChangeReportDTO;
}(DomainObject_1.DomainObject);

exports.CompetitorPriceChangeReportDTO = CompetitorPriceChangeReportDTO;

CompetitorPriceChangeReportDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CompetitorPriceChangeReportDTO.name);
  return {
    competitorId: builder.str('competitorId'),
    competitorName: builder.str('competitorName'),
    prices: builder.listOf(builder.obj('price', CompetitorReferentialPrice_1.CompetitorReferentialPrice.schema, function (mat) {
      return CompetitorReferentialPrice_1.CompetitorReferentialPrice.fromDataDict(mat);
    }))
  };
}();